export const operadoresTable = () => [
  { label: "Nombre", key: "busqueda" },
  {
    label: "Tipo",
    key: "tipo",
    alias: { excavadora: "Excavadora", retro: "Retro" },
  },
];
